import { useState, useEffect } from "react";

const TRIAL_USES_KEY = "snapbill_trial_uses";
const MAX_TRIAL_USES = 5;

export const useTrialAccess = () => {
  const [trialUsesLeft, setTrialUsesLeft] = useState<number>(MAX_TRIAL_USES);
  const [hasTrialAccess, setHasTrialAccess] = useState<boolean>(true);

  useEffect(() => {
    const storedUses = localStorage.getItem(TRIAL_USES_KEY);
    const usedCount = storedUses ? parseInt(storedUses, 10) : 0;
    const remainingUses = Math.max(0, MAX_TRIAL_USES - usedCount);
    
    setTrialUsesLeft(remainingUses);
    setHasTrialAccess(remainingUses > 0);
  }, []);

  const consumeTrialUse = () => {
    const storedUses = localStorage.getItem(TRIAL_USES_KEY);
    const usedCount = storedUses ? parseInt(storedUses, 10) : 0;
    const newUsedCount = usedCount + 1;
    
    localStorage.setItem(TRIAL_USES_KEY, newUsedCount.toString());
    
    const remainingUses = Math.max(0, MAX_TRIAL_USES - newUsedCount);
    setTrialUsesLeft(remainingUses);
    setHasTrialAccess(remainingUses > 0);
    
    return remainingUses;
  };

  const resetTrialUses = () => {
    localStorage.removeItem(TRIAL_USES_KEY);
    setTrialUsesLeft(MAX_TRIAL_USES);
    setHasTrialAccess(true);
  };

  return {
    trialUsesLeft,
    hasTrialAccess,
    consumeTrialUse,
    resetTrialUses,
    maxTrialUses: MAX_TRIAL_USES,
  };
};
